// Generated by tools/as3-to-ts from work/decomp/main/scripts/com/deviant/HueColorMatrixFilter.as; hand-edits allowed (see docs/architecture.md)

import { ColorMatrixFilter } from '@flash';
import * as as3 from '../../runtime/as3';

export class HueColorMatrixFilter {
  private matrix: any = null;
  private _h: number = 0;

  constructor() {
    as3.bindMethods(this, HueColorMatrixFilter.prototype);
    this.Identity();
  }

  private Identity(): void {
    this.matrix = [1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 1, 0];
  }

  reset(): void {
    this.Identity();
  }

  set Saturation(param1: number) {
    param1 = Number(param1);
    let _loc2_: any = null;
    let _loc3_: any = null;
    let _loc4_: any = null;
    param1 = param1 > 1 ? 1 : (param1 < 0 ? 0 : param1);
    _loc2_ = [0.213, 0.715, 0.072, 0.213, 0.715, 0.072, 0.213, 0.715, 0.072];
    _loc3_ = [0.787, -0.715, -0.072, -0.212, 0.285, -0.072, -0.213, -0.715, 0.928];
    _loc4_ = this.add(_loc2_, this.multiply(param1, _loc3_));
    this.concat([_loc4_[0], _loc4_[1], _loc4_[2], 0, 0, _loc4_[3], _loc4_[4], _loc4_[5], 0, 0, _loc4_[6], _loc4_[7], _loc4_[8], 0, 0, 0, 0, 0, 1, 0]);
  }

  set Hue(param1: number) {
    param1 = Number(param1);
    let _loc2_: any = null;
    let _loc3_: any = null;
    let _loc4_: any = null;
    let _loc5_: any = null;
    this._h = param1;
    param1 = this._h * 0.0174532925;
    _loc2_ = [0.213, 0.715, 0.072, 0.213, 0.715, 0.072, 0.213, 0.715, 0.072];
    _loc3_ = [0.787, -0.715, -0.072, -0.212, 0.285, -0.072, -0.213, -0.715, 0.928];
    _loc4_ = [-0.213, -0.715, 0.928, 0.143, 0.14, -0.283, -0.787, 0.715, 0.072];
    _loc5_ = this.add(_loc2_, this.add(this.multiply(Math.cos(param1), _loc3_), this.multiply(Math.sin(param1), _loc4_)));
    this.concat([_loc5_[0], _loc5_[1], _loc5_[2], 0, 0, _loc5_[3], _loc5_[4], _loc5_[5], 0, 0, _loc5_[6], _loc5_[7], _loc5_[8], 0, 0, 0, 0, 0, 1, 0]);
  }

  get Hue(): number {
    return this._h;
  }

  private add(param1: any, param2: any): any {
    let _loc3_: any = [];
    let _loc4_: number = 0;
    while (_loc4_ < param1.length) {
      _loc3_.push(param1[_loc4_] + param2[_loc4_]);
      _loc4_ = as3.uint(_loc4_ + 1);
    }
    return _loc3_;
  }

  private multiply(param1: number, param2: any): any {
    param1 = Number(param1);
    let _loc4_: number = NaN;
    let _loc3_: any = [];
    for (const __it1 of as3.values(param2)) {
      _loc4_ = Number(__it1);
      if (_loc4_ == 0) {
        _loc3_.push(0);
      } else {
        _loc3_.push(param1 * _loc4_);
      }
    }
    return _loc3_;
  }

  private concat(param1: any): void {
    let _loc2_: any = [];
    let _loc3_: any = this.matrix;
    _loc2_[0] = _loc3_[0] * param1[0] + _loc3_[1] * param1[5] + _loc3_[2] * param1[10];
    _loc2_[1] = _loc3_[0] * param1[1] + _loc3_[1] * param1[6] + _loc3_[2] * param1[11];
    _loc2_[2] = _loc3_[0] * param1[2] + _loc3_[1] * param1[7] + _loc3_[2] * param1[12];
    _loc2_[3] = 0;
    _loc2_[4] = 0;
    _loc2_[5] = _loc3_[5] * param1[0] + _loc3_[6] * param1[5] + _loc3_[7] * param1[10];
    _loc2_[6] = _loc3_[5] * param1[1] + _loc3_[6] * param1[6] + _loc3_[7] * param1[11];
    _loc2_[7] = _loc3_[5] * param1[2] + _loc3_[6] * param1[7] + _loc3_[7] * param1[12];
    _loc2_[8] = 0;
    _loc2_[9] = 0;
    _loc2_[10] = _loc3_[10] * param1[0] + _loc3_[11] * param1[5] + _loc3_[12] * param1[10];
    _loc2_[11] = _loc3_[10] * param1[1] + _loc3_[11] * param1[6] + _loc3_[12] * param1[11];
    _loc2_[12] = _loc3_[10] * param1[2] + _loc3_[11] * param1[7] + _loc3_[12] * param1[12];
    _loc2_[13] = 0;
    _loc2_[14] = 0;
    _loc2_[15] = 0;
    _loc2_[16] = 0;
    _loc2_[17] = 0;
    _loc2_[18] = 1;
    _loc2_[19] = 0;
    this.matrix = _loc2_;
  }

  get Filter(): any {
    return new ColorMatrixFilter(this.matrix);
  }
}
